module.exports = __webpack_public_path__ + "static/widespread-conspiracy-mobile-9e3d8dee3d78d5ff44ee132cd627d4a8.svg";